(
    function (skyward, $, undefined)
    {
        skyward.browseeditor = skyward.browseeditor || {};

        var buildInsertColumnPopup = function(browse)
        {
            var url;
            var data = {};
            if (browse.data.browseViewEditorHash)
            {
                url = skyward.global.virtualDir + "SkySys/BrowseViewEditor/BuildTreeBrowse/";
                data.postData = JSON.stringify(browse.data);
            }
            else
            {
                url = skyward.global.virtualDir + "SkySys/BrowseView/BuildTreeBrowse/";
                data.lookupModule = browse.dataModule;
                data.lookupObject = browse.dataObject;
                data.browseId = browse.browseId;
            }
            data.browseName = browse.browseName;

            return $.ajax(
            {
                url: url,
                type: "POST",
                dataType: "viewparthtml",
                data: data
            });
        };

        var insertColumn = function (listData, browse, sortFieldIndex, isLockedColumn)
        {
            if (listData === undefined || listData.fieldName === undefined)
            {
                return;
            }

            var dotIndex = listData.fieldName.indexOf(".");
            var fieldName;
            if (dotIndex > 0)
            {
                //The way the data.fieldName is structured is :
                //'[SelectedDataObject].[FieldName] and we dont want grab [SelectedDataObject].[FieldName] off of [SelectedDataObject]. We just want the fieldname
                fieldName = listData.fieldName.substring(dotIndex + 1, listData.fieldName.length);
            }
            else
            {
                fieldName = listData.fieldName;
            }

            var url;
            var data = {};
            if (browse.data.browseViewEditorHash)
            {
                url = skyward.global.virtualDir + "SkySys/BrowseViewEditor/InsertColumnFromBrowseViewEditor";
                data.postData = JSON.stringify(browse.data);
            }
            else
            {
                url = skyward.global.virtualDir + "SkySys/BrowseView/InsertColumn";
                data.pageModule = browse.pageModule;
                data.pageObject = browse.pageObject;
                data.pageScreen = browse.pageScreen;
                data.browseName = browse.browseName.replace("detailsPanel_", "");
                data.taskName = browse.taskName;
                data.browseId = browse.browseId;
            }
            data.columnIndexToInsertAfter = sortFieldIndex;
            data.fieldIsDynamic = listData.isDynamicColumn;
            data.columnFieldName = fieldName;
            data.isLockedColumn = isLockedColumn;

            return $.ajax(
            {
                url: url,
                type: "POST",
                dataType: "JSON",
                data: data,
                success: function(data)
                {
                    if (data && data.success)
                    {
                        var seekId = browse.primaryKeys[browse.currentRow];
                        skyward.browse.get(browse.id, { seekId: seekId });
                    }
                    else
                    {
                        skyward.modalLayer.showCriticalDialog("Insert Column Error", "There was an error when attempting to insert the <span class='boldFont'>" + fieldName + "</span> column.");
                    }
                }
            });
        };

        skyward.browseeditor.popInsertColumnView = function (browse, sortFieldIndex, element)
        {
            var cancelButton = { text: "Close", "click": "close", "icon": "Close" };
            var options =
            {
                anchorTo: element,
                beforeClose: function ()
                {
                    skyward.window.removeBrowseResizeCallback(dialog.close);
                }
            };
            var dialog = skyward.modalLayer.showDialog("Insert Column", function () { return buildInsertColumnPopup(browse); }, [cancelButton], options);

            dialog.content.on("treeBrowseLevelChanged", dialog.animateModalContents);
            dialog.content.on("treeBrowseSave", function (e, treeBrowseData)
            {
                if (!treeBrowseHasSelectedField(treeBrowseData))
                {
                    return;
                }

                dialog.content.off("treeBrowseSave");

                var isLockedColumn = element.closest("#" + browse.browseName + "_lockedHeader").length > 0;
                var listData = skyward.treebrowse.getSelectedFieldData(dialog.content);

                insertColumn(listData, browse, sortFieldIndex, isLockedColumn).then(dialog.close);
            });
        };

        skyward.browseeditor.deleteColumn = function (browse, fieldname, sortFieldIndex)
        {
            if (!browse)
            {
                return;
            }

            var dotIndex = fieldname.indexOf(".");
            if (dotIndex > -1)
            {
                fieldname.substring(dotIndex + 1, fieldname.length);
            }

            var url;
            var data = {};
            if (browse.data.browseViewEditorHash)
            {
                url = skyward.global.virtualDir + "SkySys/BrowseViewEditor/DeleteColumnFromBrowseViewEditor";
                data.postData = JSON.stringify(browse.data);
            }
            else
            {
                url = skyward.global.virtualDir + "SkySys/BrowseView/DeleteColumn";
                data.pageModule = browse.pageModule;
                data.pageObject = browse.pageObject;
                data.pageScreen = browse.pageScreen;
                data.browseName = browse.browseName.replace("detailsPanel_", "");
                data.taskName = browse.taskName;
            }
            data.columnIndex = sortFieldIndex;
            data.fieldName = fieldname;

            $.ajax(
            {
                url: url,
                type: "POST",
                dataType: "JSON",
                data: data,
                success: function (data)
                {
                    if (data && data.success)
                    {
                        var seekId = browse.primaryKeys[browse.currentRow];
                        skyward.browse.get(browse.id, { seekId: seekId });
                    }
                    else
                    {
                        skyward.modalLayer.showCriticalDialog("Delete Column Error", "There was an error when attempting to Delete the <span class='boldFont'>" + fieldname + "</span> column.");
                    }

                }
            });
        };

        function treeBrowseHasSelectedField(treeBrowseData)
        {
            var data = treeBrowseData.getSelectedFieldData();
            if (data === undefined)
            {
                return;
            }

            return !!data.fieldName;
        }
    }(window.skyward = window.skyward || {}, window.jQuery)
);
